export const RENTAL_MANAGER_API_V1_PREFIX = 'rental-manager-api/api/v1';

export const DispatchConstants = {
  UPDATE_SPLIT_EXPERIMENTS: 'UPDATE_SPLIT_EXPERIMENTS',
  UPDATE_SPLIT_FEATURE_NAMES: 'UPDATE_SPLIT_FEATURE_NAMES',
  DELETE_SPLIT_EXPERIMENT: 'DELETE_SPLIT_EXPERIMENT',
} as const;
